<template>
<div class="clockDetail">
     <div class='top'>
       <img src='@/assets/img/peo1.png' class='img'>
       <p><span class='name'>{{studentName}}</span><br>{{date}}&nbsp;{{weekList[week]}}</p>
     </div>
  <!--打卡-->
     <div class='reportCon'>
         <div class='con' v-if="details.beaconStat">
             <div style="text-align:center">
               <p class='rank'><span>{{details.beaconStat.surpassProportion}}</span>%</p>超过本班同学
              </div>
             <div class='curCon flex-center'>
               <p><span class='color'>{{details.beaconStat.beaconWeekNums||'0'}}</span>次<br>本周打卡</p>
               <p><span class='color'>{{details.beaconStat.beaconTermNums||'0'}}</span>次<br>本学期打卡</p>
             </div>
         </div>
         <div class="his flex-between">
            <span class="tit">打卡地点</span>
            <van-dropdown-menu>
                  <van-dropdown-item v-model="year" :options="times" @change='getList()'/>
            </van-dropdown-menu>
         <!-- <p>{{list[0].beaconDate[0]}}<van-icon name="arrow-down" /></p> -->
         </div>
         <div class='list flex-between' v-for="(item,i) in list" :key='i'>
           <p>{{item.beaconDate[1]}}月{{item.beaconDate[2]}}日<br><span>{{item.beaconDate[0]}}年</span></p>
           <p>{{item.beaconSite}}</p>
         </div>
     </div>
</div>
</template>
<script>
import {getSkipStatList,getBeaconInfoList,stat} from "@/api/api.report";
  export default {
    data() {
      return {
        date:new Date(),
        list:'',
        details:'',
        times:[{text:'2023',value:'2023'},{text:'2022',value:'2022'}],
        year:'2023',
        week:'',
        weekList:['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
        studentId:this.$route.query.studentId,
        studentName:this.$route.query.studentName,
      }
    },
    created(){
     let date=new Date();
     this.date=this.pubMethod.formatDate(date,'yyyy-MM-dd');
     this.week=date.getDay();
     this.getDetail();
     this.getList();
     
    },
    methods: {
      getDetail(){
         stat({
              studentId:this.studentId
           }).then((data) => {
            if (data && data.result) {
                 this.details=data.result;
            }
           })
       },
       getList(){
         this.list=[];
         getBeaconInfoList({
              year:this.year,
              studentId:this.studentId
           }).then((data) => {
            if (data && data.result) {
              data.result.forEach(item=>{
                item.beaconDate=item.beaconDate.split('-');
              })
              this.list=data.result
             
            }
         })
       },
       getSkip(){
         this.list=[];
         getSkipStatList({
              year:this.year,
              studentId:this.studentId
           }).then((data) => {
            if (data && data.result) {
              data.result.forEach(item=>{
                item.month=item.month.split('-');
              })
              this.list=data.result
             
            }
         })
       }
    },
  }
</script>
<style lang="scss" >
.clockDetail{
  padding:.15rem;
  .top{
      display: flex;
      align-items:center;
      font-size:.13rem;
      color:#999;
      img{
        border-radius:50%;
        width: .4rem;
        height:.4rem;
        margin-right:10px;
      }
      .name{
        font-size: .14rem;
        color:#333;
      }
    }
.reportCon{
   margin-top:20px;
   color:#999;
   font-size: .12rem;
   .van-dropdown-menu__bar{
     background:transparent;
     height: auto;
     box-shadow: none;
     margin-right: 15px;
   }
   .van-dropdown-menu__title{
     color:#7f7f7f;
     font-size: .12rem;
     &::after{
       border-color:transparent transparent #7f7f7f #7f7f7f ;
     }
   }
   .con{
     background:#fff;
     border-radius:12px;
     padding:.2rem;
     .rank{
         width: .7rem;
         height: .8rem;
         margin: 0px auto;
         background: url(../../assets/img/step/re3.png) no-repeat center top;
         background-size: 100% auto;
         color: #fff;
         span{
           font-weight: bold;
           font-size:.3rem ;
           line-height: .77rem;
           margin-right: 2px; 
         }
     }
    
     .tit{
       font-size:.15rem;
       color:#333;
     }
     .curCon{
       margin-top: .1rem;
       line-height: .3rem;
       p{
         flex: 1;
         text-align: center;
       }
       .color{
         color:#2403df;
         font-size:.18rem;
         font-weight: 500;
       }
     }
   }
   .his{
     margin:.15rem 0px .08rem;
     .tit{
       color:#333;
       font-size: .14rem;
     }
   }
   .list{
     background:#fff;
     padding:.15rem;
     color:#333;
     font-size: .14rem;
     margin-bottom: 10px;
     align-items: center;
     p:last-child{
       text-align: right;
     }
     span{
       font-size:.12rem;
       color:#999;
     }
   }
 }
}
</style>